import { PortfolioItem } from "../models/PortfolioItem.js";

/**
 * SWAP POINT: portfolio content. Add, remove or reorder items here; the grid
 * renders whatever this returns. Assets live in public/work/ (images under
 * 1.5 MB, videos under 4 MB, enforced by portfolio.test.ts). Source renders and
 * the pipeline that makes them live in work/turnstill (render_product.py).
 *
 * Every piece below is SAMPLE WORK on fictional or stock products, not client
 * work. Captions say so. Replace with real client pieces (with written
 * permission) as they are delivered. Do not add renders of third-party branded
 * products (for example the CC0 camera model) to this public grid.
 */
export function portfolioItems(): PortfolioItem[] {
  return [
    new PortfolioItem({
      id: "gadget-spin",
      kind: "spin",
      caption: "360 spin, square. Sample product",
      alt: "360 degree spin render of a rounded gadget on a dark studio background",
      src: "/work/13_gadget-dark-spin-1x1.mp4",
      poster: "/work/05_gadget-dark-hero.jpg",
    }),
    new PortfolioItem({
      id: "bottle-reel",
      kind: "spin",
      caption: "Vertical 9:16 ad reel. Concept bottle, fictional brand",
      alt: "Vertical spin of a white supplement-style bottle on a teal gradient background",
      src: "/work/14_verda-gradient-reel-9x16.mp4",
      poster: "/work/07_verda-gradient-hero.jpg",
    }),
    new PortfolioItem({
      id: "bottle-white",
      kind: "image",
      caption: "White-background main image. Concept bottle, fictional brand",
      alt: "Product bottle with a teal label on a pure white background, soft contact shadow",
      src: "/work/01_verda-white-hero.jpg",
    }),
    new PortfolioItem({
      id: "bottle-sheet",
      kind: "image",
      caption: "Client review sheet: hero, six angles and a transparent PNG",
      alt: "Contact sheet showing one product from front, side, back and top plus a transparent cut-out",
      src: "/work/12_verda-contact-sheet.jpg",
    }),
    new PortfolioItem({
      id: "cleaner-white",
      kind: "image",
      caption: "White-background hero. Sample product",
      alt: "Handheld cleaning device on a pure white background",
      src: "/work/02_cleaner-white-hero.jpg",
    }),
    new PortfolioItem({
      id: "gadget-white",
      kind: "image",
      caption: "White-background hero. Sample product",
      alt: "Rounded gadget on a pure white background with a soft shadow",
      src: "/work/03_gadget-white-hero.jpg",
    }),
    new PortfolioItem({
      id: "mug-gradient",
      kind: "image",
      caption: "Branded gradient backdrop. Sample product",
      alt: "Ceramic mug on a smooth colour gradient backdrop",
      src: "/work/08_mug-gradient-hero.jpg",
    }),
    new PortfolioItem({
      id: "vase-lifestyle",
      kind: "image",
      caption: "Soft lifestyle backdrop. Sample product",
      alt: "Decorative vase on a warm, softly lit lifestyle backdrop",
      src: "/work/09_vase-lifestyle-hero.jpg",
    }),
    new PortfolioItem({
      id: "own-product",
      kind: "image",
      caption: "Own product: premium finish study",
      alt: "Premium-finish candle warmer lamp on a dark background",
      src: "/work/luxe.jpg",
    }),
  ];
}
